import React, { createContext, useContext, useState } from 'react';

const MascotContext = createContext();

export const MascotProvider = ({ children }) => {
    // 'idle', 'watch', 'move', 'steal', 'celebrate', 'sleep', 'sitting', 'flying'
    const [mascotState, setMascotState] = useState('idle');
    const [targetPos, setTargetPos] = useState({ x: 0, y: 0 });
    const [holdingItem, setHoldingItem] = useState(null); // 'react', 'python', etc.
    const [currentSection, setCurrentSection] = useState('home');

    // Mobile Sleep Mode Detection
    React.useEffect(() => {
        const checkMobile = () => {
            if (window.innerWidth < 768) {
                setMascotState('sleep');
            } else if (mascotState === 'sleep') {
                setMascotState('idle'); // Wake up if resized back
            }
        };

        checkMobile(); // Check on mount
        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
    }, [mascotState]);

    // Values to share
    const value = {
        mascotState,
        setMascotState,
        targetPos,
        setTargetPos,
        holdingItem,
        setHoldingItem,
        currentSection,
        setCurrentSection
    };

    return (
        <MascotContext.Provider value={value}>
            {children}
        </MascotContext.Provider>
    );
};

export const useMascot = () => {
    const context = useContext(MascotContext);
    if (!context) {
        throw new Error('useMascot must be used within a MascotProvider');
    }
    return context;
};
